export const BLOCK_PROCESSING = 'BLOCK_PROCESSING'
export const BLOCKS_FAILED = 'BLOCKS_FAILED'
export const BLOCK_FAILED = 'BLOCK_FAILED'
export const BLOCK_RECEIVED = 'BLOCK_RECEIVED'
export const BLOCK_FOUND = 'BLOCK_FOUND'
export const BLOCKS_LISTENING = 'BLOCKS_LISTENING'
export const BLOCKS_POLLING = 'BLOCKS_POLLING'
